export const validateBlog = (fields) => {
  const isValid = {};

  if (fields?.title === '') {
    isValid.title = 'Enter title';
  }
  if (fields?.url === '') {
    isValid.url = 'Enter url';
  }
  return isValid;
};
